module.exports = __webpack_public_path__ + "static/media/S (106).e776b8b0.jpg";